import { Injectable, Inject } from '@angular/core';
import { AuthHttp } from 'angular2-jwt';
import { APIBase } from './api.base';
import { Router } from '@angular/router';
import { SessionStorageService } from '../services/session-storage.service';

@Injectable()
export class EdificiosAPI extends APIBase {

	constructor(@Inject(AuthHttp) authHttp: AuthHttp, @Inject(Router) router: Router, @Inject(SessionStorageService) session: SessionStorageService) {
		super(authHttp, router, session);

		// Entidade principal
		this.__entity = 'edificios';
	}
	/**
	 * save
	 *
	 * Salva os dados
	 *
	 * @access public
	 * @author Nicolas Aoki
	 * @since  11/2019
	 * @param  object
	 * @return object Promise
	 */
	public save(data) {
        // return this._call(this.__entity + '/save', data);
		return this._call(this.__entity + '/save', {data} , 'post');        
	}
	/**
	 * get by incorporadoraId
	 *
	 *
	 * @access public
	 * @author Nicolas Aoki
	 * @since  11/2019
	 * @param  object
	 * @return object Promise
	 */
	public getByEmpreendimentoId(data) {
		let dados = {
			EmpreendimentoId:data['id']
		};
		if(data['nomeEdificio']){
			dados['Nome_like']=data['nomeEdificio'];
		}
        // return this._call(this.__entity + '/save', data);
		return this._call(this.__entity, dados , 'get'); 
	}
}


// WEBPACK FOOTER //
// ./src/api/edificios.api.ts